import React from "react";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";

import Header from "common-components/Header";
import Button from "common-components/Buttons";
import Container from "common-components/Container";

import { CancelRequestModal } from "./CancelRequestModal";
import { replaceHashValues } from "utils/replaceHashValues";

const DownloadPending = ({
  pageContent: { section_title, section_description, buttons },
  dateOfRequest,
  modalContent,
  showModal,
  toggleModal,
  handleCancelClick,
  notificationMethod
}) => (
  <Container>
    {showModal ? (
      <CancelRequestModal
        modalContent={modalContent}
        dateOfRequest={dateOfRequest}
        showModal={showModal}
        toggleModal={toggleModal}
        handleCancelClick={handleCancelClick}
      />
    ) : null}
    <Header style={{ maxWidth: "227px" }}>{section_title}</Header>
    <Div>
      {convertStringToElements(
        replaceHashValues(section_description, {
          requestedDate: dateOfRequest,
          notificationMethod
        })
      )}
    </Div>
    <Button background={buttons[0].type} style={{ marginTop: "56px" }} onClick={toggleModal}>
      {buttons[0].text}
    </Button>
  </Container>
);

export { DownloadPending };

const Div = styled.div`
  max-width: 385px;

  p {
    padding: 12px 0;
  }
`;
